// Seconds, shared by the login feedback and navigation handoff.
export const LOGIN_MOTION = Object.freeze({
  fast: 0.12,
  normal: 0.2,
  slow: 0.32,
  confirm: 0.55,
  dive: 0.36,
  arrive: 0.28,
  ease: [0.4, 0, 0.2, 1],
});
